import type { GuidString } from "@/types/utilityTypes";

import { buildApiClient } from "@core/api-client/RetryableBearerApiClient";

export async function getSourceUrlAsync(id: GuidString): Promise<string> {
    return await buildApiClient(window.env.ACTIVITIES_API_URL).getAsync(`/r/${id}`);
}